import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { Arrangement } from "../../models/mechanicsConfiguration";
import { ImageBox } from "../../components/ImageBox.tsx"

interface Props {
  data: Arrangement;
  onChange: (field: keyof Arrangement, value: any) => void;
}

const ArrangementForm: React.FC<Props> = ({
  data,
  onChange,
}) => {
  const handleCountChange = (axis: "x" | "y", value: number) => {
    if (value > 0)  {
      onChange(axis, { ...data[axis], count: value });
    }
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Anordnung mehrerer DUTs
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography variant="h6" gutterBottom>
            in x-Achse
          </Typography>
          <Box mt={2} />
          <TextField
            fullWidth
            label={`Anzahl an DUTs`}
            type="number"
            value={data.x.count}
            onChange={(e) => handleCountChange("x", parseInt(e.target.value))}
          />
          <Box mt={2} />
          <TextField
            fullWidth
            label={`Offset (links)`}
            type="number"
            inputProps={{ step: 0.01, min: 0 }}
            value={data.x.offset}
            disabled={data.x.count === 1}
            onChange={(e) =>
              onChange("x", { ...data.x, offset: parseFloat(e.target.value) })
            }
          />
          <Box mt={2} />
          <TextField
            fullWidth
            label={`Abstand zwischen den Boards`}
            type="number"
            inputProps={{ step: 0.01, min: 10 }}
            value={data.x.distance}
            disabled={data.x.count === 1}
            onChange={(e) =>
              onChange("x", { ...data.x, distance: parseFloat(e.target.value) })
            }
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
        <Typography variant="h6" gutterBottom>
          in y-Achse
        </Typography>
        <Box mt={2} />
          <TextField
            fullWidth
            label={`Anzahl an DUTs`}
            type="number"
            value={data.y.count}
            onChange={(e) => handleCountChange("y", parseInt(e.target.value))}
          />
          <Box mt={2} />
          <TextField
            fullWidth
            label={`Offset (vorne)`}
            type="number"
            inputProps={{ step: 0.01, min: 0 }}
            value={data.y.offset}
            disabled={data.y.count === 1}
            onChange={(e) =>
              onChange("y", { ...data.y, offset: parseFloat(e.target.value) })
            }
          />
          <Box mt={2} />
          <TextField
            fullWidth
            label={`Abstand zwischen den Boards`}
            type="number"
            inputProps={{ step: 0.01, min: 10 }}
            value={data.y.distance}
            disabled={data.y.count === 1}
            onChange={(e) =>
              onChange("y", { ...data.y, distance: parseFloat(e.target.value) })
            }
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <ImageBox
            width="100%"
            height={247}
            src="/mechanics/Arrangement.png"
            srcDarkMode="/mechanics/Arrangement_DarkMode.png"
            alt="Anordnung"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ArrangementForm;
